import { render, staticRenderFns } from "./formSelect.vue?vue&type=template&id=135350b6&scoped=true&"
import script from "./formSelect.vue?vue&type=script&lang=js&"
export * from "./formSelect.vue?vue&type=script&lang=js&"
import style0 from "./formSelect.vue?vue&type=style&index=0&id=135350b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135350b6",
  null
  
)

export default component.exports